import { render, staticRenderFns } from "./StatisticItem.vue?vue&type=template&id=408d44d2&scoped=true&"
import script from "./StatisticItem.vue?vue&type=script&lang=js&"
export * from "./StatisticItem.vue?vue&type=script&lang=js&"
import style0 from "./StatisticItem.vue?vue&type=style&index=0&id=408d44d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d44d2",
  null
  
)

export default component.exports